import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './router'
import { getToken } from '@/utils/auth'


Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  const meta = to.meta || {};
  if(meta.isAuth === false){
    next();
  }else{
    if(getToken()){
      next();
    }else{
      next({ path: '/login' });
    }
  }
  if(to.meta.title){
    document.title = to.meta.title
  }
})

export default router